// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-1K26k";
var _4 = "footer-3qjr-";
var _5 = "content-ziSyr";
var _6 = "mobileHeader-1mBrQ";
var _7 = "continueBtn-1QImz";
var _8 = "root-1aC9G";
var _9 = "priceDescription-QzaQb";
var _a = "priceDescriptionHeader-3xEkh";
var _b = "priceDescriptionItem-3slmL";
var _c = "ofVisible-2tWjK";
var _d = "money-32AqE";
var _e = "money_old-3K_xO";
var _f = "money_new-2C06O";
var _10 = "button-2mi0q";
var _11 = "paper-1_ADB";
var _12 = "paper_mobile-3BExb";
var _13 = "bgFill-3GR-u";
var _14 = "bottom-3Ceaz";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "footer", _5 as "content", _6 as "mobileHeader", _7 as "continueBtn", _8 as "root", _9 as "priceDescription", _a as "priceDescriptionHeader", _b as "priceDescriptionItem", _c as "ofVisible", _d as "money", _e as "money_old", _f as "money_new", _10 as "button", _11 as "paper", _12 as "paper_mobile", _13 as "bgFill", _14 as "bottom" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "footer": _4, "content": _5, "mobileHeader": _6, "continueBtn": _7, "root": _8, "priceDescription": _9, "priceDescriptionHeader": _a, "priceDescriptionItem": _b, "ofVisible": _c, "money": _d, "money_old": _e, "money_new": _f, "button": _10, "paper": _11, "paper_mobile": _12, "bgFill": _13, "bottom": _14 }
